import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-no-connection-illustration',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="size()"
      [attr.height]="size()"
      viewBox="0 0 304 263"
      fill="none"
    >
      <path
        d="M155.701 242.146C219.049 242.146 270.402 190.793 270.402 127.445C270.402 64.0973 219.049 12.7439 155.701 12.7439C92.3534 12.7439 41 64.0973 41 127.445C41 190.793 92.3534 242.146 155.701 242.146Z"
        fill="url(#paint0_linear_5_945)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.28711 71.7143C23.3884 59.6438 46.16 57.3458 67.9624 58.0682C71.0778 58.1714 73.5195 60.7806 73.4163 63.8959C73.3131 67.0112 70.7039 69.453 67.5886 69.3498C46.6643 68.6565 26.4706 70.9595 9.09808 81.3914C6.42582 82.9961 2.95869 82.1306 1.35404 79.4584C-0.250621 76.7861 0.614843 73.319 3.28711 71.7143Z"
        fill="url(#paint1_linear_5_945)"
      />
      <g filter="url(#filter0_f_5_945)">
        <ellipse cx="129.237" cy="110.742" rx="69.1592" ry="11.8183" fill="#C4C1FE" />
      </g>
      <g filter="url(#filter1_f_5_945)">
        <ellipse
          cx="246.545"
          cy="109.867"
          rx="31.5156"
          ry="11.8183"
          fill="#40DFF0"
          fill-opacity="0.6"
        />
      </g>
      <g filter="url(#filter2_f_5_945)">
        <ellipse cx="171.258" cy="228.926" rx="69.1592" ry="11.8183" fill="#C4C1FE" />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M302.618 163.421C304.223 166.094 303.358 169.561 300.685 171.165C280.586 183.235 257.803 185.533 236.002 184.812C232.887 184.708 230.445 182.099 230.548 178.984C230.651 175.869 233.26 173.427 236.376 173.53C257.299 174.223 277.504 171.919 294.874 161.488C297.547 159.884 301.014 160.749 302.618 163.421Z"
        fill="url(#paint2_linear_5_945)"
      />
      <path
        d="M147.637 228.192H204.963C224.184 228.192 239.769 207.374 239.769 181.686C239.769 155.998 224.184 135.172 204.963 135.172H147.637C159.529 135.172 170.027 143.138 176.3 155.329C180.336 163.538 182.435 172.563 182.435 181.71C182.435 190.858 180.336 199.883 176.3 208.091C170.027 220.25 159.529 228.192 147.637 228.192Z"
        fill="url(#paint3_linear_5_945)"
      />
      <path
        d="M188.853 152.249C181.854 138.68 170.139 129.795 156.876 129.795H144.065C122.618 129.795 105.227 153.031 105.227 181.686C105.227 210.341 122.618 233.57 144.065 233.578H156.917C170.18 233.578 181.911 224.709 188.893 211.123C193.394 201.966 195.734 191.898 195.734 181.694C195.734 171.491 193.394 161.423 188.893 152.265L188.853 152.249Z"
        fill="url(#paint4_linear_5_945)"
      />
      <path
        d="M175.896 152.249C168.914 138.704 157.223 129.827 143.984 129.795C122.554 129.795 105.187 153.047 105.187 181.686C105.187 210.325 122.554 233.545 143.984 233.578C157.223 233.578 168.914 224.709 175.896 211.123C180.402 201.967 182.746 191.899 182.746 181.694C182.746 171.49 180.402 161.421 175.896 152.265V152.249Z"
        fill="url(#paint5_linear_5_945)"
      />
      <path
        d="M149.099 172.119C147.166 175.518 143.93 177.744 140.267 177.744H136.728C130.804 177.744 126 171.923 126 164.744C126 157.565 130.804 151.746 136.728 151.744H140.278C143.941 151.744 147.182 153.966 149.11 157.37C150.354 159.664 151 162.186 151 164.742C151 167.298 150.354 169.821 149.11 172.115L149.099 172.119Z"
        fill="url(#paint6_linear_5_945)"
      />
      <path
        d="M149.099 207.119C147.166 210.518 143.93 212.744 140.267 212.744H136.728C130.804 212.744 126 206.923 126 199.744C126 192.565 130.804 186.746 136.728 186.744H140.278C143.941 186.744 147.182 188.966 149.11 192.37C150.354 194.664 151 197.186 151 199.742C151 202.298 150.354 204.821 149.11 207.115L149.099 207.119Z"
        fill="url(#paint7_linear_5_945)"
      />
      <path
        d="M145.145 172.119C143.255 175.512 140.089 177.736 136.505 177.744C130.702 177.744 126 171.919 126 164.744C126 157.569 130.702 151.752 136.505 151.744C140.089 151.744 143.255 153.966 145.145 157.37C146.366 159.663 147 162.186 147 164.742C147 167.299 146.366 169.821 145.145 172.115V172.119Z"
        fill="#958FFF"
      />
      <path
        d="M145.145 207.119C143.255 210.512 140.089 212.736 136.505 212.744C130.702 212.744 126 206.919 126 199.744C126 192.569 130.702 186.752 136.505 186.744C140.089 186.744 143.255 188.966 145.145 192.37C146.366 194.663 147 197.186 147 199.742C147 202.299 146.366 204.821 145.145 207.115V207.119Z"
        fill="#958FFF"
      />
      <path
        d="M156.336 114.109H99.0101C79.7886 114.109 64.1953 93.2911 64.1953 67.6033C64.1953 41.9156 79.7886 21.0896 99.0101 21.0896H156.336C144.443 21.0896 133.946 29.0556 127.673 41.2464C123.559 49.4303 121.453 58.4762 121.529 67.6356C121.453 76.7925 123.559 85.8358 127.673 94.0168C133.946 106.143 144.443 114.109 156.336 114.109Z"
        fill="url(#paint8_linear_5_945)"
      />
      <path
        d="M115.112 38.1985C122.118 24.629 133.834 15.7439 147.097 15.7439H159.949C181.395 15.7439 198.787 38.9806 198.787 67.6355C198.787 96.2903 181.395 119.519 159.949 119.527H147.097C133.834 119.527 122.102 110.658 115.112 97.0724C110.531 87.9406 108.185 77.8514 108.267 67.6355C108.185 57.4195 110.531 47.3303 115.112 38.1985Z"
        fill="url(#paint9_linear_5_945)"
      />
      <path
        d="M128.068 38.1985C135.058 24.6532 146.741 15.7761 159.988 15.7439C181.419 15.7439 198.786 38.9967 198.786 67.6355C198.786 96.2742 181.419 119.495 159.988 119.519C146.741 119.519 135.058 110.65 128.068 97.0724C123.487 87.9406 121.141 77.8514 121.223 67.6355C121.141 57.4195 123.487 47.3303 128.068 38.1985Z"
        fill="url(#paint10_linear_5_945)"
      />
      <path
        d="M163.326 58.7505C167.516 58.7505 170.913 54.0361 170.913 48.2206C170.913 42.4051 167.516 37.6907 163.326 37.6907C159.136 37.6907 155.739 42.4051 155.739 48.2206C155.739 54.0361 159.136 58.7505 163.326 58.7505Z"
        fill="url(#paint11_linear_5_945)"
      />
      <path
        d="M163.5 60.7439C168.747 60.7439 173 55.1475 173 48.2439C173 41.3403 168.747 35.7439 163.5 35.7439C158.253 35.7439 154 41.3403 154 48.2439C154 55.1475 158.253 60.7439 163.5 60.7439Z"
        fill="#7F79F6"
      />
      <path
        d="M163.5 100.744C168.747 100.744 173 95.1475 173 88.2439C173 81.3403 168.747 75.7439 163.5 75.7439C158.253 75.7439 154 81.3403 154 88.2439C154 95.1475 158.253 100.744 163.5 100.744Z"
        fill="#7F79F6"
      />
      <path
        d="M50.1565 138.025C50.674 135.881 53.7237 135.881 54.2412 138.025L55.9831 145.241C56.1681 146.007 56.7663 146.605 57.5325 146.79L64.7485 148.532C66.8925 149.05 66.8925 152.099 64.7485 152.617L57.5325 154.359C56.7663 154.544 56.1681 155.142 55.9831 155.908L54.2412 163.124C53.7237 165.268 50.674 165.268 50.1565 163.124L48.4146 155.908C48.2296 155.142 47.6314 154.544 46.8652 154.359L39.6492 152.617C37.5052 152.099 37.5052 149.05 39.6492 148.532L46.8652 146.79C47.6314 146.605 48.2296 146.007 48.4146 145.241L50.1565 138.025Z"
        fill="url(#paint12_linear_5_945)"
      />
      <path
        d="M163.326 58.7505C167.516 58.7505 170.913 54.0361 170.913 48.2206C170.913 42.4051 167.516 37.6907 163.326 37.6907C159.136 37.6907 155.739 42.4051 155.739 48.2206C155.739 54.0361 159.136 58.7505 163.326 58.7505Z"
        fill="url(#paint13_linear_5_945)"
      />
      <path
        d="M163.326 98.7505C167.516 98.7505 170.913 94.0361 170.913 88.2206C170.913 82.4051 167.516 77.6907 163.326 77.6907C159.136 77.6907 155.739 82.4051 155.739 88.2206C155.739 94.0361 159.136 98.7505 163.326 98.7505Z"
        fill="url(#paint14_linear_5_945)"
      />
      <path
        d="M224.367 8.46073C224.885 6.31671 227.935 6.3167 228.452 8.46073L230.194 15.6767C230.379 16.4429 230.977 17.0411 231.743 17.2261L238.959 18.968C241.103 19.4856 241.103 22.5352 238.959 23.0528L231.743 24.7947C230.977 24.9796 230.379 25.5778 230.194 26.344L228.452 33.56C227.935 35.7041 224.885 35.7041 224.367 33.56L222.626 26.344C222.441 25.5778 221.842 24.9796 221.076 24.7947L213.86 23.0528C211.716 22.5352 211.716 19.4856 213.86 18.968L221.076 17.2261C221.842 17.0411 222.441 16.4429 222.626 15.6767L224.367 8.46073Z"
        fill="url(#paint15_linear_5_945)"
      />
      <circle
        cx="52.1993"
        cy="98.9239"
        r="4.81488"
        stroke="url(#paint16_linear_5_945)"
        stroke-width="2.6263"
      />
      <circle
        cx="251.128"
        cy="210.872"
        r="4.81488"
        stroke="url(#paint17_linear_5_945)"
        stroke-width="2.6263"
      />
      <path
        d="M246.556 131.614C246.223 130.308 247.429 129.131 248.726 129.496L257.485 131.957C258.783 132.322 259.199 133.954 258.234 134.895L251.723 141.25C250.759 142.191 249.137 141.736 248.804 140.43L246.556 131.614Z"
        fill="url(#paint18_linear_5_945)"
      />
      <path
        d="M88.9228 216.247C90.2292 215.916 91.4044 217.123 91.0381 218.42L88.5655 227.175C88.1992 228.472 86.5661 228.886 85.626 227.921L79.28 221.402C78.3398 220.436 78.7977 218.814 80.1042 218.483L88.9228 216.247Z"
        fill="url(#paint19_linear_5_945)"
      />
      <path
        d="M277.75 82.4135C276.911 88.7368 274.482 94.7441 270.691 99.8738C266.9 105.004 261.87 109.088 256.071 111.746C250.272 114.404 243.894 115.548 237.533 115.071C231.173 114.594 225.036 112.513 219.699 109.02L205.186 113.963C204.745 114.11 204.272 114.127 203.822 114.013C203.371 113.898 202.964 113.656 202.648 113.316C202.331 112.976 202.12 112.552 202.038 112.095C201.956 111.638 202.008 111.166 202.186 110.738L208.024 96.8054C204.936 91.6375 203.131 85.8056 202.758 79.7972C202.385 73.7887 203.456 67.7783 205.881 62.2683C208.306 56.7584 212.014 51.9088 216.696 48.1251C221.379 44.3414 226.899 41.7334 232.795 40.5191C238.691 39.3049 244.792 39.5196 250.589 41.1453C256.385 42.7711 261.708 45.7607 266.113 49.8642C270.517 53.9677 273.876 59.0659 275.907 64.7327C277.939 70.3995 278.585 76.4703 277.79 82.4377L277.75 82.4135Z"
        fill="url(#paint20_linear_5_945)"
      />
      <circle
        cx="123.128"
        cy="6.87192"
        r="4.81488"
        stroke="url(#paint21_linear_5_945)"
        stroke-width="2.6263"
      />
      <path
        d="M240.051 97.0605C243.567 97.0605 246.022 94.6607 246.022 91.3122C246.022 87.9078 243.567 85.508 240.051 85.508C236.591 85.508 234.079 87.9078 234.079 91.3122C234.079 94.6607 236.591 97.0605 240.051 97.0605ZM245.52 56.0968H234.582V67.0353L237.372 82.1595H242.674L245.52 67.0353V56.0968Z"
        fill="white"
      />
      <rect x="94" y="155.744" width="50" height="18" rx="9" fill="url(#paint22_linear_5_945)" />
      <rect x="94" y="190.744" width="50" height="18" rx="9" fill="url(#paint23_linear_5_945)" />
      <defs>
        <filter
          id="filter0_f_5_945"
          x="38.1923"
          y="77.0381"
          width="182.09"
          height="67.4083"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="10.9429" result="effect1_foregroundBlur_5_945" />
        </filter>
        <filter
          id="filter1_f_5_945"
          x="193.143"
          y="76.1625"
          width="106.803"
          height="67.4083"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="10.9429" result="effect1_foregroundBlur_5_945" />
        </filter>
        <filter
          id="filter2_f_5_945"
          x="80.2128"
          y="195.222"
          width="182.09"
          height="67.4083"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="10.9429" result="effect1_foregroundBlur_5_945" />
        </filter>
        <linearGradient
          id="paint0_linear_5_945"
          x1="154.817"
          y1="-24.6056"
          x2="157.167"
          y2="378.207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="1" stop-color="#9DB3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5_945"
          x1="65.0002"
          y1="82.3597"
          x2="17.128"
          y2="35.3109"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5_945"
          x1="236.04"
          y1="193.033"
          x2="282.23"
          y2="224.131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5_945"
          x1="226.241"
          y1="199.925"
          x2="167.584"
          y2="89.1873"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_5_945"
          x1="182.444"
          y1="202.04"
          x2="112.556"
          y2="85.8677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_5_945"
          x1="111.965"
          y1="188.415"
          x2="182.96"
          y2="187.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B9B6FF" />
          <stop offset="1" stop-color="#C6C4F9" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_5_945"
          x1="155"
          y1="171.744"
          x2="132.764"
          y2="140.697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_5_945"
          x1="155"
          y1="206.744"
          x2="132.764"
          y2="175.697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_5_945"
          x1="88.4999"
          y1="118.36"
          x2="84.1521"
          y2="-24.8998"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_5_945"
          x1="162.501"
          y1="96.8596"
          x2="143"
          y2="-31.0826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_5_945"
          x1="128"
          y1="74.3597"
          x2="199"
          y2="73.8597"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B9B6FF" />
          <stop offset="1" stop-color="#C6C4F9" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_5_945"
          x1="148.496"
          y1="59.1417"
          x2="207.704"
          y2="54.6687"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_5_945"
          x1="67.039"
          y1="158.816"
          x2="40.6843"
          y2="108.582"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_5_945"
          x1="158"
          y1="40.244"
          x2="213.061"
          y2="55.7789"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_5_945"
          x1="158"
          y1="80.244"
          x2="213.061"
          y2="95.7789"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_5_945"
          x1="241.25"
          y1="29.2516"
          x2="214.895"
          y2="-20.9823"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_5_945"
          x1="56.5277"
          y1="101.328"
          x2="48.8409"
          y2="86.6761"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_5_945"
          x1="255.456"
          y1="213.276"
          x2="247.77"
          y2="198.624"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_5_945"
          x1="258.745"
          y1="133.079"
          x2="236.267"
          y2="125.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_5_945"
          x1="87.442"
          y1="228.434"
          x2="94.7802"
          y2="205.965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_5_945"
          x1="202.03"
          y1="39.9244"
          x2="240.06"
          y2="115.176"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#49E2F2" />
          <stop offset="1" stop-color="#31D9EB" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_5_945"
          x1="127.456"
          y1="9.27561"
          x2="119.77"
          y2="-5.37593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_5_945"
          x1="136.658"
          y1="168.274"
          x2="107.209"
          y2="138.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_5_945"
          x1="136.658"
          y1="203.274"
          x2="131.654"
          y2="176.779"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoConnectionIllustrationComponent {
  customClass = input('');
  size = input(100);
}
